<template>
    <div class="import-opt-container">
        <v-page-header
            :back="{
                title: '组织架构',
                goBack: goback,
            }"
            title="从企业微信导入员工"
        />
        <div v-if="hasImportResult" class="import-result-tips">
            上次导入
            <span class="import-result-time">({{ lastImportTime }})</span>
            成功<span :class="{ 'import-result-succ': hasImportSucc }">{{ importSuccNum }}</span
            >人，失败<span :class="{ 'import-result-fail': hasImportFail }">{{ importFailNum }}</span
            >人<template v-if="hasImportFail">，</template>
            <a v-if="hasImportFail" :href="domloadUrl" target="_self">下载失败列表</a>
        </div>
        <v-status-bar kind="alarm" size="medium">
            <span>
                在企业微信中新建/修改员工，2个小时后才能同步到企点；系统将按照设定好的规则来导入企业微信员工
                <span style="color:#4a70ff;cursor:pointer;" @click="jumpNewPage(contactConfigPage)">
                    查看规则
                </span>
            </span>
        </v-status-bar>
        <div class="ready-content">
            <div class="ready-content-top">
                <div class="person">
                    <org-select
                        mode="inner"
                        :single="false"
                        :with-checkbox="true"
                        :selected="selectedMultiple"
                        :cust-fetch-tree="custFetchTree"
                        :cust-fetch-search="custFetchSearch"
                        @change="onChange"
                    >
                    </org-select>
                </div>
                <div class="to-update">
                    <span class="desc-txt">当导入的员工已在企点组织架构中时：</span>
                    <v-select v-model="updateInfo" :options="updateSelect" :inline="true"></v-select>
                </div>
            </div>

            <div class="button-text">
                <v-button status="primary" :loading="importIng" @click="toImport">导入</v-button>
                <v-button status="default" @click="replaceRoute('/mng/org')">取消</v-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import Gateway from '@/utils/Gateway';
import OrgSelect from '@/components/org-select';
import { getContactConfigPage } from '@/cgi/getConfig';
import { envDomain } from 'src/utils/domainConfig';

const req = require.context('../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {
        OrgSelect
    },
    data() {
        return {
            updateInfo: 2,
            updateSelect: [
                {
                    text: '更新他们的资料',
                    value: 2
                },
                {
                    text: '不更新他们的资料',
                    value: 1
                }
            ],
            selected: [],
            selectedMultiple: [],
            importIng: false,
            lastImportTime: '',
            importSuccNum: 0,
            importFailNum: 0,
            domloadUrl: `${envDomain.gateway}/v1/wework/addressbook/exportManualFailedList`,
            contactConfigPage: ''
        };
    },

    computed: {
        hasImportSucc() {
            return this.importSuccNum > 0;
        },

        hasImportFail() {
            return this.importFailNum > 0;
        },

        hasImportResult() {
            return this.hasImportSucc || this.hasImportFail;
        }
    },

    created() {
        this.getImportResult();

        getContactConfigPage().then(url => {
            this.contactConfigPage = url;
        });
    },

    methods: {
        onChange(data) {
            this.selected = data;
        },
        goback() {
            window.location.href = '/mng/org';
        },

        jumpRoute(path) {
            this.$router.push(path);
        },

        // 根路径跳转
        replaceRoute(path) {
            window.location.replace(path);
        },

        // 新开跳转
        jumpNewPage(path) {
            window.open(path, '_blank');
        },

        // 导入
        toImport() {
            if (this.selected.length === 0) {
                this.$message.error('请选择导入员工');
            } else {
                this.importReq();
            }
        },

        importReq() {
            const depts = [];
            const staffs = [];

            this.selected.forEach(item => {
                const { id, isFolder } = item || {};
                if (isFolder) {
                    depts.push(id);
                } else {
                    staffs.push(id);
                }
            });

            this.importIng = true;

            Gateway.post('/v1/wework/ManualImport', {
                depts,
                staffs,
                update_info: this.updateInfo
            })
                .then(data => {
                    const { id } = data || {};
                    this.$emit('importSuccess', id);
                    this.importIng = false;
                })
                .catch(message => {
                    this.$message.error(message || '导入失败');
                    this.importIng = false;
                });
        },

        custFetchTree(params) {
            const { isFirstFetch, id } = params;

            return Gateway.get('/v1/wework/DepTreeNode', {
                depId: isFirstFetch ? 0 : id
            }).then(data => {
                return {
                    list: this.transTreeData(data)
                };
            });
        },

        custFetchSearch(params) {
            const { keywords, index, count } = params || {};

            return Gateway.get('/v1/wework/SearchUser', {
                keyword: keywords,
                page: index + 1,
                size: count
            }).then(data => {
                return {
                    list: this.transTreeData(data)
                };
            });
        },

        transTreeData(data) {
            const { deps, users } = data || {};
            const list = [];

            if (users && users.length) {
                users.forEach(uItem => {
                    const transItem = { ...uItem };

                    transItem.id = uItem.userid;
                    transItem.isParent = 0;
                    list.push(transItem);
                });
            }

            if (deps && deps.length) {
                deps.forEach(dItem => {
                    const transItem = { ...dItem };

                    transItem.isParent = 1;
                    list.push(transItem);
                });
            }

            return list;
        },

        getImportResult() {
            Gateway.get('/v1/wework/ManualImportResult').then(data => {
                const { success, fail, last_sync_time: syncTime } = data || {};
                this.importSuccNum = success;
                this.importFailNum = fail;
                this.lastImportTime = syncTime;
            });
        }
    }
};
</script>

<style lang="less" scoped>
@import '../style.less';

.ready-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .person {
        margin-top: 34px;
        margin-bottom: 8px;
    }

    .to-update {
        display: flex;
        align-items: center;
        line-height: 27px;
    }

    .button-text {
        margin-top: 30px;
    }

    /deep/.v-select-list {
        box-shadow: 0px 8px 16px rgba(30, 36, 49, 0.16);
    }

    /deep/.v-select-list__item {
        &:hover {
            background: #ffffff;
        }
    }

    /deep/.v-select-list--single .is-selected {
        background: #ffffff;
    }

    .v-select {
        min-height: 0;
        width: 130px;

        ::v-deep.v-select__header {
            margin-top: -2px;
            padding: 0;
            border: none;
        }
        ::v-deep.v-select__header-arrow.v-icon {
            top: 9px;
            position: initial;
            margin-left: 5px;
        }
    }

    /deep/ .org-select-opt-box,
    /deep/ .org-select-res-box {
        width: 440px;

        .org-select-selected-list {
            height: 440px;
        }

        .org-select-tree-list,
        .org-select-search-list {
            height: 410px;
        }
    }
}

.import-opt-container {
    position: relative;
}

.import-result-tips {
    position: absolute;
    top: -50px;
    right: 0;
}

.import-result-time {
    color: #a1abc2;
}

.import-result-succ {
    color: #00d48a;
}

.import-result-fail {
    color: #f75559;
}

.desc-txt {
    color: #a1abc2;
}
</style>
